module.exports = __webpack_public_path__ + "img/ic_PPTX.136404f1.svg";